import React from 'react';
import useStyle from './textInput.style';

export interface TextInputProps {
  value?: string;
  placeHolder: string;
  onChange: (value) => void;
  type?: 'text' | 'email' | 'password' | 'tel';
  iconButton?: JSX.Element;
  name?: string;
  requiredValue?: boolean;
}

export const TextInput = ({
  value,
  placeHolder,
  onChange,
  type = 'text',
  iconButton,
  name,
  requiredValue = false
}: TextInputProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <input
        value={value}
        placeholder={placeHolder}
        className={classes.input}
        onChange={e => onChange(e)}
        type={type}
        name={name}
        required={requiredValue}
      />
      {iconButton && iconButton}
    </div>
  );
};
